import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }
const _hoisted_3 = { style: {"padding":"20px"} }
const _hoisted_4 = { style: {"padding":"20px"} }
const _hoisted_5 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'
import { delPlatform, addPlatform, allPlatform ,allAuthorizedPlatform,addPassagePlatform} from '../../api' 
 
 

export default /*#__PURE__*/_defineComponent({
  __name: 'appList',
  setup(__props) {

const current1 = ref("1")

const search = reactive({
  key: ""
})


const loading = ref(false);
const dataSource = ref([]);
const selectedKeys = ref([]);
const page = reactive({ current: 1, limit: 10, total: 0 });
const columns = ref([
  { title: "logo", key: "logo", align: "center" },
  { title: "名称", key: "name", align: "center" },
  { title: "app标识", key: "mark", align: "center" },
  { title: "站点状态", key: "state", align: "center" , customSlot: "state1"},
  { title: "安卓版本", key: "androidVersion", align: "center", customSlot: "androidVersion" },
  { title: "安卓提示", key: "androidTips", align: "center", ellipsisTooltip: true },
  { title: "安卓状态", key: "androidState", align: "center", customSlot: "androidState" },

  { title: "苹果版本", key: "iosVersion", align: "center", customSlot: "iosVersion" },
  { title: "苹果提示", key: "iosTips", align: "center", ellipsisTooltip: true },
  { title: "苹果状态", key: "iosState", align: "center", customSlot: "iosState" },

  { title: "第三方统计", key: "thirdPartyStatistics", align: "center", ellipsisTooltip: true },
  { title: "图片域名", key: "picture", align: "center" },
  { title: "白名单", key: "whitelist", align: "center", ellipsisTooltip: true },
  { title: "添加时间", key: "addTime", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center", width: "160px" }
]);


const getAllAllPlatform = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit, "key": search.key, "state": search.state };
  allPlatform(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}
//获取数据
getAllAllPlatform();


const change = (page: any) => {
  getAllAllPlatform();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}

//禁用或者开启
const delApp = (row: any) => {
  var data = { "id": row.id };

  delPlatform(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllAllPlatform();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}

//查询接口
const searchApp = () => {
  page.current = 1;
  getAllAllPlatform();
}

const  downloadApp = (url: any) =>{

  window.open(url, '_blank');

}

//获取授权的平台


const isauthorizedPlatform = ref(false);
const platformList= ref([]);
const authorizedId=ref([]);
const mark=ref("");
const  authorizedPlatform = (row: any) =>{ 
  mark.value=row.mark;

   var data={"key":mark.value}

  allAuthorizedPlatform(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) { 
          isauthorizedPlatform.value = true;
          platformList.value=res.data.passageList;
          authorizedId.value=res.data.authorizedId; 
        }
      }) 
}

const addAuthorized = ref([
  {
    text: "确认",
    callback: () => {
      var  data={"key":mark.value,"strId":authorizedId.value}
      addPassagePlatform(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllAllPlatform();
          isauthorizedPlatform.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      isauthorizedPlatform.value = false;
    }
  }
])




const app = reactive({
  id: 0,
  logo: "",
  name: "",
  mark: "",
  state: 0,
  androidVersion: "",
  androidDownloadUrl: "",
  androidTips: "",
  androidState: 0,
  iosVersion: "",
  iosTips: "",
  iosState: 0,
  picture: "",
  logo: "",
  key: "",
  iv: "",
  whitelist: "",
  thirdPartyStatistics:"",
  iosDownloadUrl:"",
  apiType:0,

})


const updateApp = (row: any) => {
  app.id = row.id;
  app.mark = row.mark;
  app.name = row.name;
  app.state = row.state;
  app.androidVersion = row.androidVersion;
  app.androidDownloadUrl = row.androidDownloadUrl;
  app.androidTips = row.androidTips;
  app.androidState = row.androidState;
  app.iosVersion = row.iosVersion;
  app.iosDownloadUrl = row.iosDownloadUrl;
  app.iosTips = row.iosTips;
  app.iosState = row.iosState;
  app.thirdPartyStatistics = row.thirdPartyStatistics;
  app.picture = row.picture;
  app.logo = row.logo;
  app.whitelist = row.whitelist;
  app.key = row.key,
  app.iv = row.iv,
  app.apiType=row.apiType,


  visible11.value = !visible11.value;
}

const layFormRef11 = ref();

const visible11 = ref(false);

const changeVisible11 = () => {
  app.id = 0;
  app.mark = "";
  app.name = "";
  app.state = 0;
  app.androidVersion = "";
  app.androidDownloadUrl = "";
  app.androidTips = "";
  app.androidState = 0;
  app.iosVersion = "";
  app.iosDownloadUrl = "";
  app.iosTips = "";
  app.iosState = 0;
  app.thirdPartyStatistics = "";
  app.picture = "";
  app.logo = "";
  app.whitelist = "";
  app.key = "";
  app.iv = "";
  app.apiType=0,
  visible11.value = !visible11.value;
}

const action11 = ref([
  {
    text: "确认",
    callback: () => {
      addPlatform(JSON.stringify(app)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllAllPlatform();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visible11.value = false;
    }
  }
])





return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_space = _resolveComponent("space")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_radio = _resolveComponent("lay-radio")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_line = _resolveComponent("lay-line")!
  const _component_lay_tab_item = _resolveComponent("lay-tab-item")!
  const _component_lay_tab = _resolveComponent("lay-tab")!
  const _component_lay_layer = _resolveComponent("lay-layer")!
  const _component_lay_checkbox = _resolveComponent("lay-checkbox")!
  const _component_lay_checkbox_group = _resolveComponent("lay-checkbox-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "app名称",
                      prop: "key",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入app名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchApp
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  androidVersion: _withCtx(({ row }) => [
                    (row.androidVersion)
                      ? (_openBlock(), _createBlock(_component_lay_button, {
                          key: 0,
                          type: "normal",
                          onClick: ($event: any) => (downloadApp(row.androidDownloadUrl))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.androidVersion), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  iosVersion: _withCtx(({ row }) => [
                    (row.iosVersion)
                      ? (_openBlock(), _createBlock(_component_lay_button, {
                          key: 0,
                          type: "normal",
                          onClick: ($event: any) => (downloadApp(row.iosDownloadUrl))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.iosVersion), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  iosState: _withCtx(({ row }) => [
                    (row.iosState == 1)
                      ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 强制更新 ")
                          ]),
                          _: 1
                        }))
                      : (row.iosState == 0)
                        ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 提示更新 ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ]),
                  state1: _withCtx(({ row }) => [
                    (row.state == 0)
                      ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 正常 ")
                          ]),
                          _: 1
                        }))
                      : (row.state == 1)
                        ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 关闭 ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ]),
                  androidState: _withCtx(({ row }) => [
                    (row.androidState == 1)
                      ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 强制更新 ")
                          ]),
                          _: 1
                        }))
                      : (row.androidState == 0)
                        ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 提示更新 ")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateApp(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (authorizedPlatform(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("授权平台")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (delApp(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['800px', '630px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: app,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "名称",
                prop: "name",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: app.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((app.name) = $event)),
                    placeholder: "请输入名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "app标识",
                prop: "mark",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: app.mark,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((app.mark) = $event)),
                    placeholder: "请输入app标识"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "图片域名",
                prop: "picture",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: app.picture,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((app.picture) = $event)),
                    placeholder: "请输入图片域名"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "logo",
                prop: "logo",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: app.logo,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((app.logo) = $event)),
                    placeholder: "请输入logo地址"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "站点状态",
                prop: "state"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_radio, {
                    modelValue: app.state,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((app.state) = $event)),
                    name: "state",
                    value: 0
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("正常")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_lay_radio, {
                    modelValue: app.state,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((app.state) = $event)),
                    name: "state",
                    value: 1
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("关闭")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "接口类型",
                prop: "apiType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_radio, {
                    modelValue: app.apiType,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((app.apiType) = $event)),
                    name: "apiType",
                    value: 0
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("自用")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_lay_radio, {
                    modelValue: app.apiType,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((app.apiType) = $event)),
                    name: "apiType",
                    value: 1
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("出租")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "key",
                prop: "key",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: app.key,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((app.key) = $event)),
                    placeholder: "请输入加密KEY"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "iv",
                prop: "iv",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: app.iv,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((app.iv) = $event)),
                    placeholder: "请输入加密IV"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "第三方统计",
                prop: "thirdPartyStatistics"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入第三方统计",
                    modelValue: app.thirdPartyStatistics,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((app.thirdPartyStatistics) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "白名单",
                prop: "whitelist"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入白名单",
                    modelValue: app.whitelist,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((app.whitelist) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_line),
              _createVNode(_component_lay_tab, {
                modelValue: current1.value,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((current1).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_tab_item, {
                    title: "安卓",
                    id: "1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_lay_form_item, {
                          label: "是否强制",
                          prop: "androidState"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_radio, {
                              modelValue: app.androidState,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((app.androidState) = $event)),
                              name: "androidState",
                              value: 0
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("否")
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_lay_radio, {
                              modelValue: app.androidState,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((app.androidState) = $event)),
                              name: "androidState",
                              value: 1
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("是")
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "app版本",
                          prop: "androidVersion"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: app.androidVersion,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((app.androidVersion) = $event)),
                              placeholder: "请输入版本"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "下载地址",
                          prop: "androidDownloadUrl"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: app.androidDownloadUrl,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((app.androidDownloadUrl) = $event)),
                              placeholder: "请输入下载地址"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "提示信息",
                          prop: "androidTips"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_textarea, {
                              placeholder: "请输入提示信息",
                              modelValue: app.androidTips,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((app.androidTips) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_lay_tab_item, {
                    title: "苹果",
                    id: "2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_lay_form_item, {
                          label: "是否强制",
                          prop: "iosState"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_radio, {
                              modelValue: app.iosState,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((app.iosState) = $event)),
                              name: "iosState",
                              value: 0
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("否")
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_lay_radio, {
                              modelValue: app.iosState,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((app.iosState) = $event)),
                              name: "iosState",
                              value: 1
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("是")
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "app版本",
                          prop: "iosVersion"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: app.iosVersion,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((app.iosVersion) = $event)),
                              placeholder: "请输入版本"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "下载地址",
                          prop: "iosDownloadUrl"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: app.iosDownloadUrl,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((app.iosDownloadUrl) = $event)),
                              placeholder: "请输入下载地址"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "提示信息",
                          prop: "iosTips"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_textarea, {
                              placeholder: "请输入提示信息",
                              modelValue: app.iosTips,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((app.iosTips) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: isauthorizedPlatform.value,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((isauthorizedPlatform).value = $event)),
      shade: false,
      area: ['400px', '800px'],
      btn: addAuthorized.value,
      title: "授权平台"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_lay_checkbox_group, {
            modelValue: authorizedId.value,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((authorizedId).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformList.value, (platform) => {
                return (_openBlock(), _createBlock(_component_lay_checkbox, {
                  name: "like",
                  skin: "primary",
                  value: platform.id,
                  style: {"margin":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(platform.passageName), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})